module.exports = __webpack_public_path__ + "static/media/empty.cc212d35.svg";